import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-banner-rivoneed';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Buy Now',
  backgroundColor: '#ff0000',
  color: '#ffffff',
  radius: 4,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});
const html = `
<div class="container-rivoneed">
  <div data-use-banner-mobile="true" data-attribute="wrap-banner" class="wrap-banner">
    <div class="banner-desktop">
      <img data-attribute="banner-desktop-img"
        src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a7093ea7118f9f4070c69.png" alt="" />
    </div>
    <div class="banner-mobile">
      <img data-attribute="banner-mobile-img"
        src="https://cdn.skyfastimg.com/images/2026/06/12/image-6a2b80fe89ce8399410747f6.png" alt="" />
    </div>
    <div data-show="show" data-attribute="list-small-image-mobile" data-show="true" class="list-small-image-mobile">
      <a data-attribute="small-image-item" data-href="#" class="small-image-item">
        <img data-attribute="small-image-img"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fcf15b9ccabba5339eb4a.png" alt="" />
      </a>
      <a data-attribute="small-image-item" data-href="#" class="small-image-item">
        <img data-attribute="small-image-img"
          src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a6c411ca1f23d1dd6a5be.png" alt="" />
      </a>
      <a data-attribute="small-image-item" data-href="#" class="small-image-item">
        <img data-attribute="small-image-img"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fd250b0be7ae11e0f0b33.png" alt="" />
      </a>
      <a data-attribute="small-image-item" data-href="#" class="small-image-item">
        <img data-attribute="small-image-img"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fd017abe44d605e454857.png" alt="" />
      </a>
    </div>
  </div>
  <div class="position-content">
    <div class="container">
      <div class="wrap-content" data-attribute="wrap-content" data-width-content="625" data-padding-top="40"
        data-padding-bottom="40"
        style="--padding-top-content: 40px; --padding-bottom-content: 40px; --width-content: 625px">
        <div class="list-tag" data-show="true" data-attribute="list-tag" data-border-radius="20"
          data-border-color="#ffffff" data-background-color-tag="#ffffff23" data-text-color-tag="#ffffff" style="
            --border-radius: 20px;
            --border-color: #ffffff;
            --background-color-tag: #ffffff23;
            --text-color-tag: #ffffff;
          ">
          <div class="item-tag">
            <span data-attribute="text-tag-item" class="text-tag-item">Snap On. Whole Engine Bay Lights Up.</span>
          </div>
        </div>
        <div class="text-content" data-attribute="text-content" data-show="true">
          <h2 style="color: #ffffff">Multi-Function Magnetic Swivel Work Light</h2>
          <p style="color: #ffffff">
            No more holding a light. The magnet holds it for you, the swivel head lights every corner, and one charge
            lasts your whole weekend of repairs.
          </p>
        </div>
        <div data-attribute="block-rating" data-show="true" class="block-rating">
          <div data-attribute="stars" data-value="4" class="stars">
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="#FFA800"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="#FFA800"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="#FFA800"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="#FFA800"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>
          </div>
          <div class="rating-text">21 Vélemény</div>
        </div>
        <div class="list-pill" data-attribute="list-pill" data-background-pill="#ffffff" data-color-pill="#000000"
          data-show="true" style="--background-pill: #ffffff; --color-pill: #000000">
          <div class="item-pill">
            <span class="icon-pill-item">
              <img data-attribute="icon-pill-item"
                src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fccaee65478c082999576.png" alt="" />
            </span>
            <span data-attribute="text-pill-item" class="text-pill-item">3000LM Flood Light</span>
          </div>
          <div class="item-pill">
            <span class="icon-pill-item">
              <img data-attribute="icon-pill-item"
                src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fccb31df1010daa6286a1.png" alt="" />
            </span>
            <span data-attribute="text-pill-item" class="text-pill-item">Strong Magnet Mounts</span>
          </div>
        </div>
        <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
        <div data-attribute="list-small-image" data-show="true" class="list-small-image">
          <a data-attribute="small-image-item" data-href="#" class="small-image-item">
            <img data-attribute="small-image-img"
              src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fcf15b9ccabba5339eb4a.png" alt="" />
          </a>
          <a data-attribute="small-image-item" data-href="#" class="small-image-item">
            <img data-attribute="small-image-img"
              src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a6c411ca1f23d1dd6a5be.png" alt="" />
          </a>
          <a data-attribute="small-image-item" data-href="#" class="small-image-item">
            <img data-attribute="small-image-img"
              src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fd250b0be7ae11e0f0b33.png" alt="" />
          </a>
          <a data-attribute="small-image-item" data-href="#" class="small-image-item">
            <img data-attribute="small-image-img"
              src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fd017abe44d605e454857.png" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
  topPadding: false,
  bottomPadding: false,
});
